<template>
  <div class="page">
    <div class="lyh_top">
      <span class="switchClass" @click="openSwitch">
        <img src="../../assets/img/switching.png"/>
      </span>
    </div>
    <div class="imgClass">
      <img src="../../assets/img/qrcode.png"/>
    </div>
    <div>
      <h2 class="card-title">{{$t('cardLoop.cardTitle')}}</h2>
      <nut-textinput placeholder="ICCID" id="inputTest" ref="inputTest"  maxlength="20" v-model.trim="iccid"/>
      <h2 class="card-desc">{{$t('cardLoop.cardDesc')}}</h2>
      <nut-button type="default" block @click="query" class="cx-class">{{$t('cardLoop.query')}}</nut-button>
      <nut-button block  shape="circle"  type="light" class="app-down" @click="handleAppStore">
        <img src="../../assets/img/ios.png"/>
      </nut-button>
      <nut-button block  shape="circle" type="light" class="app-down" @click="handleGoogle">
        <img src="../../assets/img/android.png"/>
      </nut-button>
    </div>
    <nut-picker
      :is-visible="isVisible"
      :list-data="languageData"
      :default-value-data="defaultValueData"
      @close="closeSwitch"
      @confirm="confirm"
    ></nut-picker>
  </div>
</template>
<script>
import lang from '@/utils/lang'
import { wx_validate } from "@/api/api.js"; //查询卡
export default {
  data() {
    return {
      iccid:undefined,
      isVisible: false,
      languageData: [],
      // 英语 西班牙语 德语 意大利语 法语 日本
      defaultValueData:[['English', 'Español', 'Deutsch', 'Italiano', 'Français', '日语']],
      currencyL:""
    };
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    // 查询按钮
    query(){
      if(!this.iccid){
        this.$toast.warn('Please enter iccid');
      }else{
        let params ={
          iccid:this.iccid,
        }
        params.code = this.code
        wx_validate(params).then(res => {
          if (res.data.code == 200) {
            this.$router.push({
              name: "cardInfo",
              query: {
                iccid: this.iccid,
              }
            });
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      }
    },
    openSwitch(){
      this.isVisible = true;
      document.getElementsByClassName("nut-picker-cancel-btn")[0].innerText = this.$t('common.cancel');
      document.getElementsByClassName("nut-picker-confirm-btn")[0].innerText = this.$t('common.confirm');
    },
    closeSwitch() {
      this.isVisible = false;
    },
    confirm(chooseData) {
      const lang = chooseData[0];
      this.$store.commit('SET_LANGUAGE', lang)
      this.$i18n.locale = this.language;
      this.initData()
    },
    handleAppStore(){
      window.open('https://apps.apple.com/cn/app/orangemobile/id6612032046')
    },
    handleGoogle(){
      window.open('https://play.google.com/store/apps/details?id=com.orangemobile.iot')
    },
    // 初始化数据
    initData(){
      window.document.title = this.$t('cardLoop.title');
    },

  },
  created() {
    this.languageData = [lang.values()]
    this.initData()
  },
  mounted(){
  }
};
</script>
<style scoped lang="less">
.page{
  .lyh_top{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: right;
    .switchClass{
      display: inline-block;
      width: 30px;
      height: 30px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .card-title{
    min-height: 30px;
    font-size: 16px;
  }
  .card-desc{
    min-height: 30px;
    font-size: 14px;
    color: #909ca4;
    padding: 10px 0px;
    font-weight: 500;
  }
  .app-down{
    min-height: 50px;
    width:100%;
    margin-bottom: 5px;
  }
  .imgClass{
    width: 100%;
    text-align: center;
    img{
      width: 80%;
    }
  }
  .i-search {
    background-image: url(../../assets/img/search.png);
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: 100%;
    vertical-align: middle;
    margin: 0 6px 0 10px;
  }
  padding: 40px 30px 0px 30px;
  /deep/ .nut-textinput{
    margin: 0 auto;
    border: 2px solid #DADADA;
    height: 45px;
    line-height: 41px;
    border-radius: 5px;
    input{
      border: 1px solid #fff;
      font-size: 15px;
    }
  }
  /deep/ .nut-button.block{
    margin: 25px auto;
    display: block;
    height: 45px;
    font-size: 16px;
    border-radius:5px;
  }
  /deep/ .nut-picker-cancel-btn{
    width: 80px;
    color: var(--nut-picker-cancel-color, #808080);
  }
    /deep/ .nut-picker-confirm-btn{
    width: 80px;
    color: var(--nut-picker-ok-color, var(--nut-primary-color, #fa2c19));
  }
  .cx-class{
    background: #ABD3F7 !important;
    border: 1px solid #ABD3F7 !important;
  }
}
</style>

